import dayjs from 'dayjs';
import React from 'react';
import { Badge } from 'reactstrap';

const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const Columns = (print) => {
	let columns = [
		{
			id: 'type',
			name: 'Tipo Vencimiento',
			center: true,
			selector: row => row?.document,
		},
		{
			id: 'nombre',
			name: 'Nombre',
			center: true,
			selector: row => row?.name,
		},
		{
			id: 'date_expiration',
			name: 'Fecha de vencimiento',
			center: true,
			selector: row => row?.date_expiration ? dayjs(row.date_expiration).format('DD/MMM/YYYY').toUpperCase() : '',
		},
		{
			id: 'expire_in',
			name: 'Días para vencimiento',
			center: true,
			selector: row => row.expire_in > 0 ? <Badge color='success'>{row.expire_in}</Badge> : <Badge color='danger'>{row.expire_in}</Badge>,
			minWidth: '300px'
		}
	];
	return columns;
}

export default Columns;